// @flow
import React, { Component } from 'react';
import {
  Text, TextArea, Checkbox, Radio, RadioGroup, Select, Option,
} from 'informed';
import NumericText from '../../../NumericText.jsx';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  pain: Object,
}

const publicUrl = process.env.PUBLIC_URL || '';

class ViewPain extends Component<Props> {
  render() {
    const pain = this.props.pain || {};
    return (
      <ContentBox title='Pain'>
        <div className={styles.col}>
          <PrimaryText>Pain</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Do you have pain now?</SecondaryText><br />
            <RadioGroup field='pain.painNow' initialValue={pain.painNow}>
              <Radio disabled value='yes' />Yes<br />
              <Radio disabled value='no' />No<br />
              <Radio disabled value='nonverbal' />Nonverbal
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Location of pain:</SecondaryText><br />
            <TextArea disabled field='pain.painLocation' initialValue={pain.painLocation} />
          </div>
          <div className={styles.section}>
            <SecondaryText>Frequency of pain:</SecondaryText><br />
            <RadioGroup field='pain.painFreq' initialValue={pain.painFreq}>
              <Radio disabled value='constant' />Constant<br />
              <Radio disabled value='intermittent' />Intermittent<br />
              <Radio disabled value='unable' />Unable to report
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Intensity of pain:</SecondaryText><br />
            <RadioGroup field='pain.painIntense' initialValue={pain.painIntense}>
              <Radio disabled value='0' />0
              <Radio disabled value='1' />1
              <Radio disabled value='2' />2
              <Radio disabled value='3' />3
              <Radio disabled value='4' />4
              <Radio disabled value='5' />5<br />
              <Radio disabled value='6' />6
              <Radio disabled value='7' />7
              <Radio disabled value='8' />8
              <Radio disabled value='9' />9
              <Radio disabled value='10' />10<br />
              <Radio disabled value='unable' />Unable to Give Verbal Report
            </RadioGroup>
          </div>
          <PrimaryText>Behavioral Assessment of Pain Intensity:</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Wong-Baker FACES pain rating scale</SecondaryText><br />
            <RadioGroup field='pain.painFaceRating' initialValue={pain.painFaceRating}>
              <table>
                <tbody>
                  <tr>
                    <td><Radio disabled value='0' />0 No Hurt</td>
                    <td><img src={`${publicUrl}/sa_assets/wong_baker_0.png`} alt='no hurt' height="64" width="64" /></td>
                  </tr>
                  <tr>
                    <td><Radio disabled value='2' />2 Hurts Little Bit</td>
                    <td><img src={`${publicUrl}/sa_assets/wong_baker_2.png`} alt='hurts little bit' height="64" width="64" /></td>
                  </tr>
                  <tr>
                    <td><Radio disabled value='4' />4 Hurts Little More</td>
                    <td><img src={`${publicUrl}/sa_assets/wong_baker_4.png`} alt='hurts little more' height="64" width="64" /></td>
                  </tr>
                  <tr>
                    <td><Radio disabled value='6' />6 Hurts Even More</td>
                    <td><img src={`${publicUrl}/sa_assets/wong_baker_6.png`} alt='hurts even more' height="64" width="64" /></td>
                  </tr>
                  <tr>
                    <td><Radio disabled value='8' />8 Hurts Whole Lot</td>
                    <td><img src={`${publicUrl}/sa_assets/wong_baker_8.png`} alt='hurts whole lot' height="64" width="64" /></td>
                  </tr>
                  <tr>
                    <td><Radio disabled value='10' />10 Hurts Worst</td>
                    <td><img src={`${publicUrl}/sa_assets/wong_baker_10.png`} alt='hurts worst' height="64" width="64" /></td>
                  </tr>
                </tbody>
              </table>
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Nonverbal cues of pain (mark all that apply):</SecondaryText><br />
            <Checkbox disabled field='pain.moan' initialValue={pain.moan} />Moaning<br />
            <Checkbox disabled field='pain.groan' initialValue={pain.groan} />Groaning<br />
            <Checkbox disabled field='pain.grunt' initialValue={pain.grunt} />Grunting<br />
            <Checkbox disabled field='pain.cry' initialValue={pain.cry} />Crying<br />
            <Checkbox disabled field='pain.grasp' initialValue={pain.grasp} />Grasping<br />
            <Checkbox disabled field='pain.sigh' initialValue={pain.sigh} />Sighing<br />
            <Checkbox disabled field='pain.grimace' initialValue={pain.grimace} />Grimacing<br />
            <Checkbox disabled field='pain.whine' initialValue={pain.whine} />Whining<br />
            <Checkbox disabled field='pain.clench' initialValue={pain.clench} />Clenching Teeth<br />
            <Checkbox disabled field='pain.guard' initialValue={pain.guard} />Guarding<br />
            <Checkbox disabled field='pain.restless' initialValue={pain.restless} />Restlessness<br />
            <Checkbox disabled field='pain.irritable' initialValue={pain.irritable} />Irritability<br />
            <Checkbox disabled field='pain.anxiety' initialValue={pain.anxiety} />Anxiety<br />
            <Checkbox disabled field='pain.inattention' initialValue={pain.inattention} />Inattention<br />
            <Checkbox disabled field='pain.withdraw' initialValue={pain.withdraw} />Withdrawal
          </div>
          <div className={styles.section}>
            <SecondaryText>Physiological cues of pain:</SecondaryText><br />
            <Checkbox disabled field='pain.increasedCues' initialValue={pain.increasedCues} />Increased Cues of Pain<br />
            <Checkbox disabled field='pain.tachycardia' initialValue={pain.tachycardia} />Tachycardia<br />
            <Checkbox disabled field='pain.tachypnea' initialValue={pain.tachypnea} />Tachypnea<br />
            <Checkbox disabled field='pain.pupilDilate' initialValue={pain.pupilDilate} />Pupil Dilation, Vasoconstriction<br />
            <Checkbox disabled field='pain.diaphoresis' initialValue={pain.diaphoresis} />Diaphoresis
          </div>
          <div className={styles.section}>
            <SecondaryText>Quality of pain (mark all that apply):</SecondaryText><br />
            <Checkbox disabled field='pain.pierce' initialValue={pain.pierce} />Piercing<br />
            <Checkbox disabled field='pain.stab' initialValue={pain.stab} />Stabbing<br />
            <Checkbox disabled field='pain.throb' initialValue={pain.throb} />Throbbing<br />
            <Checkbox disabled field='pain.dull' initialValue={pain.dull} />Dull<br />
            <Checkbox disabled field='pain.sharp' initialValue={pain.sharp} />Sharp<br />
            <Checkbox disabled field='pain.nagging' initialValue={pain.nagging} />Nagging<br />
            <Checkbox disabled field='pain.burning' initialValue={pain.burning} />Burning<br />
            <Checkbox disabled field='pain.shooting' initialValue={pain.shooting} />Shooting<br />
            <Checkbox disabled field='pain.aching' initialValue={pain.aching} />Aching<br />
            <Checkbox disabled field='pain.tingling' initialValue={pain.tingling} />Tingling<br />
            <Checkbox disabled field='pain.searing' initialValue={pain.searing} />Searing<br />
            <Checkbox disabled field='pain.cramping' initialValue={pain.cramping} />Cramping
          </div>
          <div className={styles.section}>
            <SecondaryText>More information (Quality of Pain):</SecondaryText><br />
            <TextArea disabled field='pain.painQualityInfo' initialValue={pain.painQualityInfo} />
          </div>
          <div className={styles.section}>
            <SecondaryText>Aggravating factors (mark all that apply):</SecondaryText><br />
            <Checkbox disabled field='pain.movement' initialValue={pain.movement} />Movement<br />
            <Checkbox disabled field='pain.coughing' initialValue={pain.coughing} />Coughing<br />
            <Checkbox disabled field='pain.position' initialValue={pain.position} />Positioning<br />
            <Checkbox disabled field='pain.exerciseAgg' initialValue={pain.exerciseAgg} />Exercise<br />
            <Checkbox disabled field='pain.urination' initialValue={pain.urination} />Urination<br />
            <Checkbox disabled field='pain.bowel' initialValue={pain.bowel} />Bowel Movement<br />
            <Checkbox disabled field='pain.otherAgg' initialValue={pain.otherAgg} />Other
          </div>
          <div className={styles.section}>
            <SecondaryText>More information (aggravating factors):</SecondaryText><br />
            <TextArea disabled field='pain.aggravatingInfo' initialValue={pain.aggravatingInfo} />
          </div>
          <div className={styles.section}>
            <SecondaryText>Relieving factors (mark all that apply):</SecondaryText><br />
            <Checkbox disabled field='pain.rest' initialValue={pain.rest} />Rest<br />
            <Checkbox disabled field='pain.exerciseRel' initialValue={pain.exerciseRel} />Exercise<br />
            <Checkbox disabled field='pain.heat' initialValue={pain.heat} />Heat<br />
            <Checkbox disabled field='pain.cold' initialValue={pain.cold} />Cold<br />
            <Checkbox disabled field='pain.guidedImage' initialValue={pain.guidedImage} />Guided Imagery<br />
            <Checkbox disabled field='pain.massage' initialValue={pain.massage} />Massage<br />
            <Checkbox disabled field='pain.changePos' initialValue={pain.changePos} />Change of Position<br />
            <Checkbox disabled field='pain.distract' initialValue={pain.distract} />Distraction<br />
            <Checkbox disabled field='pain.nonNarcMeds' initialValue={pain.nonNarcMeds} />Nonnarcotic Medication<br />
            <Checkbox disabled field='pain.narcMeds' initialValue={pain.narcMeds} />Narcotic Medication
          </div>
          <div className={styles.section}>
            <SecondaryText>More information (relieving factors):</SecondaryText><br />
            <TextArea disabled field='pain.relievingInfo' initialValue={pain.relievingInfo} />
          </div>
          <div className={styles.section}>
            <SecondaryText>Note: if patient is cognitively impaired, use the FLACC Scale</SecondaryText>
          </div>
          <PrimaryText>FLACC Behavioral Pain Assessment Scale</PrimaryText>
          <div className={styles.section}>
            Note: Each of the 5 categories - (F) Face, (L) Legs, (A) Activity,
            (C) Cry, and (C) Consolability - is scored from 0 to 2, resulting in a total score
            betweeen 0 and 10.
            <br />
              Note: The FLACC scale should not be used with patients who are paralyzed.<br />
              Patients Who Are Awake: Observe patient for at least 2 to 5 minutes. Observe legs
              and body uncovered. Reposition patient or observe activity and assess body for
              tenseness and tone. Initate consoling interventions if needed.<br />
              Patients Who Are Asleep: Observe patient for at least 5 minutes. Observe legs and
              body uncovered. If possible, reposition the patient. Touch the body and assess for
              tenseness and tone.<br />
          </div>
          <PrimaryText>FLACC Behavioral Pain Scale (for Infants and Cognitively Impaired)</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Face</SecondaryText><br />
            <RadioGroup field='pain.flaccFace' initialValue={pain.flaccFace}>
              <Radio disabled value='0' />0 = No Particular Expression or Smile<br />
              <Radio disabled value='1' />1 = Occasional Grimace or Frown, Withdrawn, Uninterested<br />
              <Radio disabled value='2' />2 = Frequent to Constant Frown, Clenched Jaw, Quivering Chin
            </RadioGroup>
            <br />
                Score 0 point if patient has a relaxed face, eye contact and interest in surroundings.<br />
                Score 1 point if patient has a worried look with eyebrows lowered, eyes partially
                closed, cheeks raised, mouth pursed.<br />
                Score 2 points if patient has deep furrows in the forehead, closed eyes, open mouth,
                and deep lines around nose/lips.
          </div>
          <div className={styles.section}>
            <SecondaryText>Legs</SecondaryText><br />
            <RadioGroup field='pain.flaccLegs' initialValue={pain.flaccLegs}>
              <Radio disabled value='0' />0 = Normal Position or Relaxed<br />
              <Radio disabled value='1' />1 = Uneasy, Restless, Tense<br />
              <Radio disabled value='2' />2 = Kicking, or Legs Drawn Up
            </RadioGroup>
            <br />
              Score 0 point if patient has usual tone and motion of limbs (legs and arms).<br />
              Score 1 point if patient has increased tone, rigidity, tenseness, intermittent
              flexion/extension of limbs.<br />
              Score 2 points if patient exhibits hypertonicity, legs pulled tight, exaggerated
              flexion/extension of limbs, tremors.
          </div>
          <div className={styles.section}>
            <SecondaryText>Activity</SecondaryText><br />
            <RadioGroup field='pain.flaccActivity' initialValue={pain.flaccActivity}>
              <Radio disabled value='0' />0 = Lying quietly, normal position, moves easily<br />
              <Radio disabled value='1' />1 = Squirming, shifting back and forth, tense<br />
              <Radio disabled value='2' />2 = Arched, rigid or jerking
            </RadioGroup>
            <br />
              Score 0 point if patient moves easily and freely, normal activity/restrictions.<br />
              Score 1 point if patient shifts positions, hesitant to move, guarding, tense torso,
              pressure on body part.<br />
              Score 2 points if patient is in fixed position, rocking, side-to-side movement,
              rubbing body part.
          </div>
          <div className={styles.section}>
            <SecondaryText>Cry</SecondaryText><br />
            <RadioGroup field='pain.flaccCry' initialValue={pain.flaccCry}>
              <Radio disabled value='0' />0 = No Cry (Awake or Asleep)<br />
              <Radio disabled value='1' />1 = Moaning or Whimpering; Ocasional Complaint<br />
              <Radio disabled value='2' />2 = Crying steadily, Screams or Sobs, Frequent Complaints
            </RadioGroup>
            <br />
              Score 0 point if patient exhibits no crying or moaning, awake or asleep.<br />
              Score 1 point if patient occasionally moans, cries, whimpers, sighs.<br />
              Score 2 points if patient exhibits frequent/continuous moaning, crying, grunting.
          </div>
          <div className={styles.section}>
            <SecondaryText>Consolability</SecondaryText><br />
            <RadioGroup field='pain.flaccConsole' initialValue={pain.flaccConsole}>
              <Radio disabled value='0' />0 = Content, Relaxed<br />
              <Radio disabled value='1' />1 = Reassured by Occasional Touching, Hugging, or Other Comforting<br />
              <Radio disabled value='2' />2 = Difficult to Console or Comfort
            </RadioGroup>
            <br />
              Score 0 point if patient is calm and does not require consoling.<br />
              Score 1 point if patient responds to comfort by touch or talk in 30 seconds to 1 minute.<br />
              Score 2 points if patient requires constant comforting or cannot be consoled.
          </div>
          <div className={styles.section}>
            <SecondaryText>Total FLACC Score: </SecondaryText>
            <Text disabled field='pain.flaccTotal' initialValue={pain.flaccTotal} size={4} /><br />
              0 Relaxed and Comfortable<br />
              1-3 Mild Discomfort<br />
              4-6 Moderate Pain<br />
              7-10 Severe Discomfort/Pain
          </div>
          <PrimaryText>Wound Assessment</PrimaryText><br />
          <Checkbox disabled field='pain.healedWound' initialValue={pain.healedWound} />Healed Wound
          <table>
            <tbody>
              <tr className={styles.topAlign}>
                <td>Type of wound:</td>
                <td>
                  <RadioGroup field='pain.woundType' initialValue={pain.woundType}>
                    <Radio disabled value='acute' /> Acute<br />
                    <Radio disabled value='chronic' /> Chronic
                  </RadioGroup>
                </td>
              </tr>
              <tr>
                <td>Location:</td>
                <td><Text field='pain.woundLocation' initialValue={pain.woundLocation} size={8} /></td>
              </tr>
              <tr>
                <td>Etiology</td>
                <td>
                  <Select disabled field='pain.woundEtiology' initialValue={pain.woundEtiology}>
                    <Option value=''>Select Value...</Option>
                    <Option value='surgical'>Surgical</Option>
                    <Option value='laceration'>Laceration</Option>
                    <Option value='ulcer'>Ulcer</Option>
                    <Option value='burn'>Burn</Option>
                    <Option value='abrasion'>Abrasion</Option>
                    <Option value='traumatic'>Traumatic</Option>
                    <Option value='pressure injury'>Pressure Injury</Option>
                    <Option value='neoplastic'>Neoplastic</Option>
                  </Select>
                </td>
              </tr>
              <tr>
                <td>Length (cm):</td>
                <td><NumericText disabled field='pain.woundLength' initialValue={pain.woundLength} size={4} /></td>
              </tr>
              <tr>
                <td>Width (cm):</td>
                <td><NumericText disabled field='pain.woundWidth' initialValue={pain.woundWidth} size={4} /></td>
              </tr>
              <tr className={styles.topAlign}>
                <td>Depth:</td>
                <td>
                  <RadioGroup field='pain.woundDepth' initialValue={pain.woundDepth}>
                    <Radio disabled value='superficial' /> Superficial (only epidermis affected)<br />
                    <Radio disabled value='partial' /> Partial thickness (epidermis and dermis affected)<br />
                    <Radio disabled value='full' /> Full thickness (wound extends into subcutaneous tissue or beyond)
                  </RadioGroup>
                </td>
              </tr>
              <tr className={styles.topAlign}>
                <td>Color (mark all that apply):</td>
                <td>
                  <Checkbox disabled field='pain.woundRed' initialValue={pain.woundRed} /> Red<br />
                  <Checkbox disabled field='pain.woundYellow' initialValue={pain.woundYellow} /> Yellow<br />
                  <Checkbox disabled field='pain.woundBlack' initialValue={pain.woundBlack} /> Black<br />
                  <Checkbox disabled field='pain.woundOther' initialValue={pain.woundOther} /> Other (indicate in notes)
                </td>
              </tr>
              <tr className={styles.topAlign}>
                <td>Drainage level:</td>
                <td>
                  <RadioGroup field='pain.woundDrainageLevel' initialValue={pain.woundDrainageLevel}>
                    <Radio disabled value='dry' /> Dry<br />
                    <Radio disabled value='low' /> Low<br />
                    <Radio disabled value='medium' /> Medium<br />
                    <Radio disabled value='high' /> High
                  </RadioGroup>
                </td>
              </tr>
              <tr className={styles.topAlign}>
                <td>Drainage type (mark all that apply):</td>
                <td>
                  <Checkbox disabled field='pain.woundDrainageThin' initialValue={pain.woundDrainageThin} /> Thin/Watery<br />
                  <Checkbox disabled field='pain.woundDrainageThick' initialValue={pain.woundDrainageThick} /> Thick<br />
                  <Checkbox disabled field='pain.woundDrainageCloudy' initialValue={pain.woundDrainageCloudy} /> Cloudy<br />
                  <Checkbox disabled field='pain.woundDrainagePurulent' initialValue={pain.woundDrainagePurulent} /> Purulent (yellow/brown/green)<br />
                  <Checkbox disabled field='pain.woundDrainagePink' initialValue={pain.woundDrainagePink} /> Pink/red
                </td>
              </tr>
              <tr className={styles.topAlign}>
                <td>Odor:</td>
                <td>
                  <RadioGroup field='pain.woundOdor' initialValue={pain.woundOdor}>
                    <Radio disabled value='none' /> None<br />
                    <Radio disabled value='foul' /> Foul<br />
                    <Radio disabled value='other' /> Other (indicate in notes)
                  </RadioGroup>
                </td>
              </tr>
              <tr className={styles.topAlign}>
                <td>Type of tissue in wound base:</td>
                <td>
                  <Checkbox disabled field='pain.woundTissueSlough' initialValue={pain.woundTissueSlough} /> Slough<br />
                  <Checkbox disabled field='pain.woundTissueEschar' initialValue={pain.woundTissueEschar} /> Eschar<br />
                  <Checkbox disabled field='pain.woundTissueGranulation' initialValue={pain.woundTissueGranulation} /> Granulation tissue<br />
                  <Checkbox disabled field='pain.woundTissueEpithelial' initialValue={pain.woundTissueEpithelial} /> Epithelial
                </td>
              </tr>
              <tr className={styles.topAlign}>
                <td>Wound edges (mark all that apply):</td>
                <td>
                  <Checkbox disabled field='pain.woundEdgePink' initialValue={pain.woundEdgePink} /> Pink<br />
                  <Checkbox disabled field='pain.woundEdgeDry' initialValue={pain.woundEdgeDry} /> Dry<br />
                  <Checkbox disabled field='pain.woundEdgeIntact' initialValue={pain.woundEdgeIntact} /> Intact<br />
                  <Checkbox disabled field='pain.woundEdgeMoist' initialValue={pain.woundEdgeMoist} /> Moist<br />
                  <Checkbox disabled field='pain.woundEdgeInflamed' initialValue={pain.woundEdgeInflamed} /> Inflamed<br />
                  <Checkbox disabled field='pain.woundEdgeReddened' initialValue={pain.woundEdgeReddened} /> Reddened<br />
                  <Checkbox disabled field='pain.woundEdgeDusky' initialValue={pain.woundEdgeDusky} /> Dusky colored<br />
                  <Checkbox disabled field='pain.woundEdgeTender' initialValue={pain.woundEdgeTender} /> Tender<br />
                  <Checkbox disabled field='pain.woundEdgeUndermining' initialValue={pain.woundEdgeUndermining} /> Undermining<br />
                  <Checkbox disabled field='pain.woundEdgeRolled' initialValue={pain.woundEdgeRolled} /> Rolled<br />
                  <Checkbox disabled field='pain.woundEdgeLocalWarmth' initialValue={pain.woundEdgeLocalWarmth} /> Local warmth
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <SecondaryText>Dressing and wound care:</SecondaryText><br />
            <TextArea disabled field='pain.woundDressing' initialValue={pain.woundDressing} />
          </div>
          <div>
            <SecondaryText>Notes:</SecondaryText><br />
            <TextArea disabled field='pain.woundNotes' initialValue={pain.woundNotes} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default ViewPain;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/view/ViewPain.jsx